webpackJsonp([9],{

/***/ 3403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_forum_mixin__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__repositories_ForumRepository__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__ = __webpack_require__(124);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forum',
  components: {
    BFormSelect: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["x" /* BFormSelect */],
    BBadge: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["b" /* BBadge */],
    BaseButton: __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_BaseButton__["default"],
    'forum-article-block': function forumArticleBlock() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1266)).then(function (m) {
        return m.default;
      });
    },
    'base-button': function baseButton() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 124)).then(function (m) {
        return m.default;
      });
    },
    'LoginForm': function LoginForm() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1245)).then(function (m) {
        return m.default;
      });
    }
  },
  props: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_forum_mixin__["a" /* default */]],
  data: function data() {
    return {
      activitySource: [],
      sortOptions: [{ value: 0, text: this.$t('orderBy') }, { value: 1, text: this.$t('moreRecent') }, { value: 2, text: this.$t('featured') }]
    };
  },
  created: function created() {
    this.$store.state.forum.hideSearcher = false;
    this.getForumData();
    if (this.inWhoInSection && this.$store.getters['session/healthyCommunityActive']) {
      this.getActivities();
    }
  },

  computed: {},
  methods: {
    forumFormSended: function forumFormSended() {
      this.getForumData();
    },
    loadMoreEntries: function loadMoreEntries() {
      this.$store.state.forum.entriesPageNumber += 1;
      this.getForumData();
    },
    getForumData: function getForumData() {
      this.loadForumEntries();
    },
    sortSelect: function sortSelect() {
      this.$store.state.forum.entriesPageNumber = 0;
      this.getForumData();
    },
    resetWhoInFilters: function resetWhoInFilters() {
      this.$store.commit('forum/setActivityFilterSelected', null);
      this.$store.commit('forum/setActivityFilters', {});
      this.getForumData();
    },
    getActivities: function getActivities() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__repositories_ForumRepository__["a" /* default */].getActivities(true, true).then(function (response) {
        _this.activitySource = response.data;
      });
    },
    searchActivity: function searchActivity(activityId, createdByUser) {
      var _this2 = this;

      if (this.$store.state.forum.activityFilterSelected === activityId) {
        this.$store.commit('forum/setActivityFilterSelected', null);
        this.resetWhoInFilters();
      } else {
        this.$store.commit('forum/setActivityFilterSelected', activityId);
        var filter = createdByUser ? { otherActivities: true } : { activity: activityId };
        __WEBPACK_IMPORTED_MODULE_2__repositories_ForumRepository__["a" /* default */].searchActivity(filter).then(function (response) {
          if (response.data && response.data.entryData.length > 0) {
            _this2.processForumEntry(response.data);
          } else {
            _this2.$store.dispatch('showInfoAlert', _this2.$t('emptyActivitiesSearch'));
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 4162:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4163);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("10fb0ab1", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-08dea57c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Forum.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-08dea57c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Forum.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4163:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.order-bar{width:50vw !important;margin-left:auto !important;margin-right:auto !important;-webkit-box-orient:horizontal !important;-webkit-box-direction:normal !important;-ms-flex-direction:row !important;flex-direction:row !important;margin-bottom:3vh !important\n}\n@media only screen and (max-width: 575px){\n.order-bar{-webkit-box-orient:vertical !important;-webkit-box-direction:normal !important;-ms-flex-direction:column !important;flex-direction:column !important;margin-bottom:3.5vh !important\n}\n.order-bar .custom-select-forum{margin-left:0px !important\n}\n.order-bar .back-btn-search{margin-bottom:2vh !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.order-bar{-webkit-box-orient:vertical !important;-webkit-box-direction:normal !important;-ms-flex-direction:column !important;flex-direction:column !important;margin-bottom:3.5vh !important\n}\n.order-bar .custom-select-forum{margin-left:0px !important\n}\n.order-bar .back-btn-search{margin-bottom:2vh !important\n}\n}\n.custom-select-forum{margin-bottom:0px !important\n}\n.activity-filter-block{cursor:pointer;margin-right:1rem;padding:.7em 1em;color:#3238C4;border:1px solid #3238C4;background-color:transparent;margin-top:1rem\n}\n.activity-selected{background-color:#3238C4;color:#eee\n}\n", ""]);

// exports


/***/ }),

/***/ 4164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.inWhoInSection
        ? _c(
            "div",
            { staticClass: "verticalCenter order-bar" },
            [
              _c("b-form-select", {
                staticClass: "order-by offset-sm-5 custom-select-forum",
                attrs: { options: _vm.sortOptions },
                on: { input: _vm.sortSelect },
                model: {
                  value: _vm.$store.state.forum.searchSort,
                  callback: function($$v) {
                    _vm.$set(_vm.$store.state.forum, "searchSort", $$v)
                  },
                  expression: "$store.state.forum.searchSort"
                }
              })
            ],
            1
          )
        : Object.keys(this.$store.state.forum.activityFilters).length
        ? _c(
            "div",
            [
              _c(
                "base-button",
                { attrs: { white: "" }, on: { click: _vm.resetWhoInFilters } },
                [_vm._v(_vm._s(_vm.$t("resetFilters")))]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.inWhoInSection && _vm.activitySource.length
        ? _c(
            "div",
            _vm._l(_vm.activitySource, function(item) {
              return _c(
                "b-badge",
                {
                  key: item.id,
                  staticClass: "activity-filter-block",
                  class: {
                    "activity-selected":
                      _vm.$store.state.forum.activityFilterSelected === item.id
                  },
                  on: {
                    click: function($event) {
                      return _vm.searchActivity(item.id, item.createdByUser)
                    }
                  }
                },
                [_vm._v(_vm._s(item[_vm.normalizeForumProp("name")]))]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("forum-article-block", {
        staticStyle: { "min-height": "100vh" },
        attrs: { hideForumDescriptionMobile: "" },
        on: { loadMoreEntries: _vm.loadMoreEntries }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08dea57c", esExports)
  }
}

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forum_vue__ = __webpack_require__(3403);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08dea57c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forum_vue__ = __webpack_require__(4164);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4162)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08dea57c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forum_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/healthy-community/forum/Forum.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-08dea57c", Component.options)
  } else {
    hotAPI.reload("data-v-08dea57c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/9.0717cffb2031434355b2.js